angular
	.module('AutoPrequal')
	.controller('applicantNameCtrl', applicantNameCtrl);

applicantNameCtrl.$inject = ['$scope', '$rootScope', 'ScrollFactory', 'DataFactory', 'SessionFactory'];

function applicantNameCtrl($scope, $rootScope, ScrollFactory, DataFactory, SessionFactory) {

	$rootScope.progressCurrent = 1;
	$rootScope.progressMobCurrent = 1;

	$scope.content = DataFactory.appData.content;
	$scope.localContent = DataFactory.appData.content.applicantName;

	$scope.data = DataFactory.appData.applicant;
	$scope.formatFirstName = formatFirstName;
	$scope.formatLastName = formatLastName;

	$rootScope.name = $scope.data.apFirstName;
	$rootScope.lastName = $scope.data.apLastName;


	$rootScope.applicantNameNextStep = function () {
		if ($scope.Name.$valid) {
			formatFirstName();
			formatLastName();
			$rootScope.name = $scope.data.apFirstName;
			$rootScope.lastName = $scope.data.apLastName;

			//wait until Session has successfully been created before continuing
			var continueNextStep = function () {
				DataFactory.appData.applicant.appState.applicantName = true;

				DataFactory.setData($scope.data);

				ScrollFactory.showStep("applicantContact");
				ScrollFactory.goToStep("applicantContact");
			}
			if (SessionFactory.sessionId) {
				continueNextStep();
			} else {
				$rootScope.forcedLoader = true;
				var unwatch = $scope.$watch(function () { return SessionFactory.sessionId }, function (sessionId) {
					if (sessionId) {
						unwatch();
						$rootScope.forcedLoader = false;
						continueNextStep();
					}
				})
			}
			return true;
		}
		else {
			angular.forEach($scope.Name.$error, function (field) {
				angular.forEach(field, function (errorField, index) {
					errorField.$setTouched();
					$rootScope.errorNumber = index + 1;
				})
			});
		}
	}

	$scope.prevStep = function () {
		ScrollFactory.showStep("welcome");
		ScrollFactory.goToStep("welcome");
	}

	function formatFirstName() {
		if ($scope.Name.apFirstName.$valid) {
			var name = $scope.data.apFirstName;
			var nameRegex = new RegExp(/^([A-Za-z]{1}\.?){2}$/);
			if (nameRegex.test(name)) name = name.toUpperCase();
			else {
				name = name.toLowerCase();
				name = name.charAt(0).toUpperCase() + name.slice(1);
			}
			$scope.data.apFirstName = name;
		}
	}

	function formatLastName() {
		if ($scope.Name.apLastName.$valid) {
			var name = $scope.data.apLastName;
			var nameRegex = new RegExp(/^([A-Za-z]{1}\.?){2}$/);
			if (nameRegex.test(name)) name = name.toUpperCase();
			else {
				name = name.toLowerCase();
				name = name.charAt(0).toUpperCase() + name.slice(1);
			}
			$scope.data.apLastName = name;
		}
	}
}
